import { useRef } from 'react';
import classNames from 'classnames/bind';
import { AppToaster } from 'components/common/AppToaster/AppToaster';

import SidebarMenu from 'components/common/SidebarMenu';
import { backgroundColorStyle, Banner, BannerType, borderColorStyle } from 'lib/Banner';

const cx = classNames;

type Props = {
  isRequiredMarketData: boolean;
  bannerType: BannerType;
  isAuthenticatedView: boolean;
  isAuthChecked: boolean;
  isPublicCampaignPlanRoute: boolean;
  children: React.ReactNode;
};

const AppPageWrapper: React.FC<Props> = ({
  children,
  isRequiredMarketData,
  bannerType,
  isAuthenticatedView,
  isAuthChecked,
  isPublicCampaignPlanRoute,
}) => {
  const hasBeenAuthenticated = useRef(false);

  if (isAuthenticatedView) {
    hasBeenAuthenticated.current = true;
  }

  const showSidebarLayout = isPublicCampaignPlanRoute
    ? isAuthChecked && isAuthenticatedView
    : isAuthenticatedView || hasBeenAuthenticated.current;

  if (!showSidebarLayout) {
    return <div>{children}</div>;
  }

  return (
    <div className={cx('body-base font-inter bg-primary-950')}>
      <SidebarMenu isRequiredMarketData={isRequiredMarketData} />

      <div
        className={cx(
          'border-6 rounded h-screen overflow-hidden ml-15 flex flex-col',
          bannerType === BannerType.NONE
            ? 'border-primary-950'
            : `${borderColorStyle[bannerType]} ${backgroundColorStyle[bannerType]}`,
        )}
      >
        <div className="flex flex-col h-full z-10">
          <Banner />
          <div className="flex-grow rounded bg-neutral-100 overflow-hidden">{children}</div>
        </div>
      </div>
      <AppToaster />
    </div>
  );
};

export default AppPageWrapper;
